/*
 * @Author: Teemo Ding
 * @Date: 2021-09-16 10:24:06
 * @LastEditTime: 2022-06-02 11:23:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/DNSRecordRecommendation/index.tsx
 */
import { Alert, Button, Checkbox, Form } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { SSLStatusType } from '@/src/types/common/domain';
import { Collapse } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const { Item } = Form;
const { Panel } = Collapse;

const DNSRecordRecommendation = ({
  certificateStatus,
  domain,
  status,
  oldCertificateStatus,
  awsDistributionDomainName,
  awsDistributionDomainIp,
  certificate,
  verifyDomain,
  verifiedDate,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);
  const wwwRegex = new RegExp('^www.');
  const wwwDomain = wwwRegex.test(domain);
  const wwwDomainUrl = (domain || '').replace(wwwRegex, '');
  const domainLength = (domain || '').split('.').length - 1;
  const rootDomain = domainLength == 1;
  const subDomain = domainLength == 2;
  const disabledAll = false; //!oldCertificateStatus || !certificate || !domain; //Teemo修改

  const cancelSubmission = () => {
    console.log('111111');
  };

  const renderAlert = (statusItem) =>
    statusItem == SSLStatusType.Pending ||
    statusItem == SSLStatusType.Invalid ? (
      <Alert
        className={css.certificateAlert}
        {...(statusItem == SSLStatusType.Pending
          ? {
              action: (
                <Button className={css.infoType} onClick={cancelSubmission}>
                  {getI18n('salesChannelDomainAndStatus.edit.cancelSubmission')}
                </Button>
              ),
            }
          : {})}
        closable={statusItem == SSLStatusType.Pending ? false : true}
        message={
          statusItem == SSLStatusType.Pending
            ? getI18n(
                'salesChannelDomainAndStatus.edit.domainVerificationProcessing',
              )
            : getI18n(
                'salesChannelDomainAndStatus.edit.domainVerificationFailed',
              )
        }
        showIcon
        type={statusItem == SSLStatusType.Pending ? 'info' : 'error'}
        icon={
          <Icon
            type={
              statusItem == SSLStatusType.Pending ? 'iconpending' : 'iconfailed'
            }></Icon>
        }
        description={
          statusItem == SSLStatusType.Pending
            ? getI18n('salesChannelDomainAndStatus.edit.statusItemPending')
            : getI18n('salesChannelDomainAndStatus.edit.statusItemnotPending')
        }
      />
    ) : null;
  const renderItem = (
    <div>
      {renderAlert(status)}
      <p className={css.recordRecommendation}>
        {getI18n('salesChannelDomainAndStatus.edit.recordRecommendation')}
        <a>{getI18n('salesChannelDomainAndStatus.edit.viewinstructions')}</a>
      </p>
      {!domain && !certificate && (
        <p>
          {getI18n('salesChannelDomainAndStatus.edit.nodomaincertificatetips')}
        </p>
      )}
      {!!domain && (wwwDomain || subDomain) && (
        <div>
          <p className={css.wwwDomainTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.updateCNAMEof')}{' '}
            <span className={css.green}>{domain}</span>{' '}
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle4')}
            <span className={css.awsDistributionDomainName}>
              {awsDistributionDomainName}
            </span>
          </p>
          <p>
            {getI18n('salesChannelDomainAndStatus.edit.getCNAMEdetailstips')}
          </p>
        </div>
      )}
      {!!domain && wwwDomain && (
        <div>
          <p className={css.wwwDomainTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle1')}{' '}
            <span className={css.green}>{wwwDomainUrl}</span>{' '}
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle2')}:
          </p>
          <p className={css.wwwDomainContent}>
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainContent')}{' '}
          </p>
        </div>
      )}
      {!!domain && rootDomain && (
        <div>
          <p className={css.wwwDomainTitle}>
            {getI18n(
              'salesChannelDomainAndStatus.edit.updateArecordtoIPaddress',
            )}
          </p>
          <p>{awsDistributionDomainIp}</p>
        </div>
      )}
      {!!domain && rootDomain && (
        <p className={css.wwwDomainTitle}>
          {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle1')}{' '}
          <span className={css.green}>www.{domain}</span>{' '}
          {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle3')}
          <span className={css.green}>www.{domain}</span>{' '}
          {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle4')}{' '}
          <span className={css.green}>{domain}</span>​
        </p>
      )}
      <Item name='notify' className={css.notify} valuePropName='checked'>
        <Checkbox disabled={disabledAll}>
          {getI18n('salesChannelDomainAndStatus.edit.notifyme')}
        </Checkbox>
      </Item>
      <Button
        type='primary'
        disabled={disabledAll}
        onClick={verifyDomain}
        className={css.primaryButton}>
        {getI18n('salesChannelDomainAndStatus.edit.verifyConnection')}
      </Button>
    </div>
  );
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      titleOnClick={() => setFold(!fold)}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'}></Icon>}
      hideContent={!fold}
      title={getI18n(
        'salesChannelDomainAndStatus.edit.dNSRecordRecommendation',
      )}>
      {status == SSLStatusType.Verified && (
        <div className={css.certificateVerified}>
          <p className={css.certificateTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.sSLCertificateVerified')}
          </p>
          <p className={css.verifiedData}>
            {getI18n('salesChannelDomainAndStatus.edit.verifiedon')}{' '}
            {moment(verifiedDate).format('MMM DD, YYYY')}
          </p>
        </div>
      )}
      {status == SSLStatusType.Verified ? (
        <Collapse className={css.collapse} ghost>
          <Panel
            key='1'
            header={getI18n(
              'salesChannelDomainAndStatus.edit.updateSSLCertificate',
            )}>
            {renderItem}
          </Panel>
        </Collapse>
      ) : (
        renderItem
      )}
    </SectionWrapper>
  );
};

export default DNSRecordRecommendation;
